import {useQuery} from 'react-query';
import {getLoanValidationResult} from './getLoanValidationResult';

const useGetLoanValidationResult = (loanGuid?: string) => {
  const {data, isLoading} = useQuery({
    queryKey: ['loan-validation-result'],
    queryFn: () => getLoanValidationResult(loanGuid),
    enabled: Boolean(loanGuid),
  });

  return {data, isLoading};
};

export default useGetLoanValidationResult;
